import type { IncomingMessage } from 'http';
import { Globals } from './Globals';
import { useServices } from './Services';
import { SsrData } from './SsrData';
import { parseBrowserInfo } from './parseBrowserInfo.server-only';

export class BrowserService {
  constructor(private ssrData: SsrData, private globals?: Globals, private req?: IncomingMessage) {}

  public info: BrowserInfo = this.ssrData.slot('BROWSER_INFO', () =>
    this.req && parseBrowserInfo ? parseBrowserInfo(this.req) : {},
  );

  public isOutdated = () => this.info.agent?.name === 'IE';
  public window = this.globals?.window;
  public document = this.globals?.document;
}

export const useBrowser = () => useServices().browser;

export interface BrowserInfo {
  device?: IUAParser.IDevice;
  agent?: IUAParser.IBrowser;
}
